
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tim-viec-lam",
      function () {
        return require("private-next-pages/tim-viec-lam/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tim-viec-lam"])
      });
    }
  